import { ReactNode } from "react";
import { Flex, Text } from "rebass";
import styled, { css } from "styled-components";
import {
  BiCompass,
  BiSolidCompass,
  BiDotsHorizontalRounded,
  BiUser,
  BiSolidUser,
  BiJoystick,
  BiPalette,
  BiTrophy,
  BiVideo,
  BiGift,
} from "react-icons/bi";
import {
  MdMovieEdit,
  MdOutlineVideoLibrary,
  MdVideoLibrary,
} from "react-icons/md";
import { useSetRecoilState } from "recoil";

import { SidebarExpandedState } from "../../State/sidebar";
import { useMediaQuery } from "../../Hooks/useMediaQuery";
import theme from "../../../theme/themeThree";
import { Divider } from "../Divider";
import { ReactComponent as HistoryLogo } from "../../Assets/Nav/nav-history.svg";
import { HiOutlineUserGroup, HiUserGroup } from "react-icons/hi";

export const NavItem = ({
  children,
}: {
  children?: ReactNode | ReactNode[];
}) => {
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints[1]})`);
  const setExpanded = useSetRecoilState(SidebarExpandedState);
  const collapseOnMobile = () => isMobile && setExpanded(false);

  return (
    <Flex style={{ width: "100%" }} onClick={() => collapseOnMobile()}>
      {children}
    </Flex>
  );
};

export const NavLinkText = styled(Text)`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: ${({ theme }) => theme.fontSizes[2]};
  font-weight: 500;
  white-space: nowrap;
`;

export const sidebarContainerStyle = css`
  background-color: ${({ theme }) => theme.colors.navy600};
  border-right: 1px solid ${({ theme }) => theme.colors.navy400};
  padding: 16px;
`;

export const sidebarIconStyle = css`
  color: ${({ theme }) => theme.colors.chalk};
  height: 20px;
  width: 20px;
`;

export const navLinkActive = css`
  background: ${({ theme }) => theme.colors.envyAlpha10};

  * {
    color: ${({ theme }) => theme.colors.envy};
  }
`;

export const navLinkActiveFill = css`
  background: ${({ theme }) => theme.colors.envyAlpha10};

  * {
    color: ${({ theme }) => theme.colors.envy};
  }

  svg {
    fill: ${({ theme }) => theme.colors.envy};
  }
`;

export const StyledBiCompass = styled(BiCompass)`
  ${sidebarIconStyle}
`;

export const StyledBiCompassFilled = styled(BiSolidCompass)`
  ${sidebarIconStyle}
`;

export const StyledBiUser = styled(BiUser)`
  ${sidebarIconStyle}
`;

export const StyledBiUserFilled = styled(BiSolidUser)`
  ${sidebarIconStyle}
`;

export const StyledTeamsLogo = styled(HiOutlineUserGroup)`
  ${sidebarIconStyle}
`;

export const StyledTeamsLogoFilled = styled(HiUserGroup)`
  ${sidebarIconStyle}
`;

export const StyledHistoryLogo = styled(HistoryLogo)`
  ${sidebarIconStyle}

  fill: ${({ theme }) => theme.colors.chalk};
`;

export const StyledBiPalette = styled(BiPalette)`
  ${sidebarIconStyle}
`;

export const StyledBiTrophy = styled(BiTrophy)`
  ${sidebarIconStyle}
`;

export const StyledBiJoystick = styled(BiJoystick)`
  ${sidebarIconStyle}
`;

export const StyledBiVideo = styled(BiVideo)`
  ${sidebarIconStyle}
`;

export const StyledBiDotsHorizontalRounded = styled(BiDotsHorizontalRounded)`
  ${sidebarIconStyle}
`;

export const StyledBiEdit = styled(MdMovieEdit)`
  ${sidebarIconStyle}
`;

export const StyledFreeClips = styled(BiGift)`
  ${sidebarIconStyle}
`;

export const StyledMdOutlineVideoLibrary = styled(MdOutlineVideoLibrary)`
  ${sidebarIconStyle}
`;

export const StyledMdVideoLibrary = styled(MdVideoLibrary)`
  ${sidebarIconStyle}
`;

export const StyledDivider = styled(Divider)`
  width: 100%;
  margin: 0;
`;
